import { useCreateEntity } from '@abaninja/util-store';

import { createDeepBoxShareWithUser } from '../deepbox';

export const useDeepBoxShareWithUserStore = () => useCreateEntity(createDeepBoxShareWithUser);
